import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainLayout from './layouts/LoginLayout';
import DashboardLayout from "./layouts/DashboardLayout";
import StudentsLayout from "./layouts/StudentsLayout";
import InvoicesLayout from "./layouts/InvoicesLayout";
import ExpensesLayout from "./layouts/ExpensesLayout";
import PaymentsLayout from "./layouts/PaymentsLayout";
import BalancesLayout from "./layouts/BalancesLayout";
import StudentInvoicesLayout from "./layouts/StudentInvoicesLayout";
import ViewInvoice from "./pages/ViewInvoice";
import ViewExpense from "./pages/ViewExpense";
import ReceiptLayout from "./layouts/ReceiptLayout";
import JournalLayout from "./layouts/JournalLayout";
import AppLayout from "./layouts/AppLayout";
import PayrollLayout from "./layouts/PayrollLayout";
import TrialLayout from "./layouts/TrialLayout";

import AccountLayout from "./layouts/AccountLayout";
import SalariesLayout from "./layouts/SalaryLayout";
import VoteheadLayout from "./layouts/VoteheadLayout";

import PosLayout from "./layouts/PosLayout";

import BulkImportLayout from "./layouts/BulkImportLayout";

import PosMainLayout from "./layouts/PosMainLayout";
import ParentFeeLayout from "./layouts/ParentFeeLayout";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout/>} />
        <Route path="/BulkImport" element={<BulkImportLayout/>} />
         <Route path="/apps" element={<AppLayout/>} />
         <Route path="/ParentPortal" element={<ParentFeeLayout/>} />
          <Route path="/pos" element={<PosMainLayout/>} />
          <Route path="/e-commerce-and-pos" element={<PosLayout/>} />
           <Route path="/Voteheads/:mode" element={<VoteheadLayout/>} />
           <Route path="/salaries" element={<SalariesLayout/>} />
        <Route path="/dashboard" element={<DashboardLayout/>} />
         <Route path="/payroll" element={<PayrollLayout/>} />
        <Route path="/students" element={<StudentsLayout/>} />
         <Route path="/invoices" element={<InvoicesLayout/>} />
         <Route path="/expenses" element={<ExpensesLayout/>} />
           <Route path="/payments" element={<PaymentsLayout/>} />
            <Route path="/balances" element={<BalancesLayout/>} />
        <Route path="/students/:id/invoices" element={<StudentInvoicesLayout />} />
           <Route path="/students/:id/viewinvoice" element={<ViewInvoice />} />
            <Route path="viewexpense/:id" element={<ViewExpense />} />
            <Route path="/students/:id/viewreceipt" element={<ReceiptLayout />} />
<Route path="/journals" element={<JournalLayout />} />
<Route path="/trial-balance" element={<TrialLayout />} />
<Route path="/chart-of-accounts" element={<AccountLayout />} />
      </Routes>
    </Router>
   
  );
}

export default App;
